import React from 'react'

import css from './Arrow.css'

const POSITION_CLASSES = {
  left: css['arrow--left'],
  top: css['arrow--top'],
  right: css['arrow--right'],
  bottom: css['arrow--bottom'],
}

type Position = 'left' | 'top' | 'right' | 'bottom'

const getArrowClasses = (position: string) => {
  const [positionY, positionX] = position.split('-') as Position[]

  return `${css.arrow} ${POSITION_CLASSES[positionY]} ${
    positionX ? POSITION_CLASSES[positionX] : ''
  }`
}

type ArrowProps = {
  positionY?: string
  position?: string
  style?: React.CSSProperties
}

const Arrow = ({ positionY = 'top', position = 'top', style = {} }: ArrowProps) =>
  position.includes(positionY) ? (
    <span className={getArrowClasses(position)} style={style}>
      {position.includes('top') ? '▲' : '▼'}
    </span>
  ) : null

export { Arrow, getArrowClasses }
